import { StorageSerializers, useStorage } from '@vueuse/core'

export const apiUrlMap = {
  Dev: 'https://api-leisureking.vitrion.nl',
  Production: 'https://api-leisureking.vitrion.nl',
  Local: 'https://api-leisureking.vitrion.nl',
}

const defaultApiUrl = (() => {
  const hostname = window.location.hostname
  if (hostname.includes('leisureking.dev'))
    return apiUrlMap.Dev
  if (hostname.includes('leisureking.vitrion.nl'))
    return apiUrlMap.Production
  return apiUrlMap.Local
})()

function createConfigStore() {
  const debugMode = useStorage<boolean>('debugMode', false, sessionStorage, { serializer: StorageSerializers.boolean })
  const apiUrl = useStorage<string>('apiUrl', defaultApiUrl, sessionStorage, { serializer: StorageSerializers.string })

  const setApiUrl = (url: string) => {
    apiUrl.value = url
  }
  const resetApiUrl = () => {
    apiUrl.value = defaultApiUrl
  }

  return {
    debugMode,
    setApiUrl,
    resetApiUrl,
    apiUrl,
  }
}

type ConfigStoreInterface = ReturnType<typeof createConfigStore>
let backwardsCompatibleInstance: null | ConfigStoreInterface = null
export function useConfigStore(): ConfigStoreInterface {
  if (backwardsCompatibleInstance === null)
    backwardsCompatibleInstance = createConfigStore()

  return backwardsCompatibleInstance
}
export default useConfigStore
